export class SetDisplayData {
  static readonly type = '[DISPLAY_DATA] SetDisplayData';
  constructor(public payload: any) {} // TODO create complex data model to include data for all matrix types
}

export class ResetDisplayData {
  static readonly type = '[DISPLAY_DATA] ResetDisplayData';
}
